import React from 'react';

// Translation dictionaries for the application
export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Employees',
    visitors: 'Visitors',
    accessLogs: 'Access Logs',
    unifiControl: 'UniFi Control',
    sensors: 'Sensors',
    automation: 'Automation',
    configuration: 'Configuration',
    branding: 'Branding',
    profile: 'Profile',
    harvest: 'Harvest',
    roomControl: 'Room Control',
    administration: 'Administration',
    controlPanel: 'Control Panel',
    
    // Navigation Categories
    facilityManagement: 'Facility Management',
    systemControl: 'System Control',
    cultivation: 'Cultivation',
    dashboardOverview: 'Dashboard Overview',
    accessValidation: 'Access Validation',
    employeeAccess: 'Employee Access',
    cameraManagement: 'Camera Management',
    sensorAdoption: 'Sensor Adoption',
    roomDisplayManager: 'Room Display Manager',
    
    // Task Management
    taskManagement: 'Task Management',
    taskDashboard: 'Task Dashboard',
    taskList: 'Task List',
    taskForm: 'Task Form',
    budgetOverview: 'Budget Overview',
    projectEstimator: 'Project Estimator',
    teamWorkload: 'Team Workload',
    
    // Task Properties
    task: 'Task',
    tasks: 'Tasks',
    title: 'Title',
    description: 'Description',
    status: 'Status',
    priority: 'Priority',
    assignee: 'Assignee',
    dueDate: 'Due Date',
    estimatedHours: 'Estimated Hours',
    actualHours: 'Actual Hours',
    budget: 'Budget',
    spent: 'Spent',
    project: 'Project',
    tags: 'Tags',
    
    // Task Status
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    overdue: 'Overdue',
    cancelled: 'Cancelled',
    
    // Task Priority
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    urgent: 'Urgent',
    
    // Task Actions
    createTask: 'Create Task',
    editTask: 'Edit Task',
    deleteTask: 'Delete Task',
    assignTask: 'Assign Task',
    completeTask: 'Complete Task',
    startTask: 'Start Task',
    pauseTask: 'Pause Task',
    
    // Task Form
    taskTitle: 'Task Title',
    taskDescription: 'Task Description',
    selectAssignee: 'Select Assignee',
    selectProject: 'Select Project',
    selectPriority: 'Select Priority',
    selectStatus: 'Select Status',
    addTags: 'Add Tags',
    estimatedTime: 'Estimated Time (hours)',
    budgetAmount: 'Budget Amount',
    
    // Budget Management
    budgetManagement: 'Budget Management',
    totalBudget: 'Total Budget',
    totalSpent: 'Total Spent',
    remainingBudget: 'Remaining Budget',
    budgetUtilization: 'Budget Utilization',
    costPerHour: 'Cost per Hour',
    hourlyRate: 'Hourly Rate',
    projectCosts: 'Project Costs',
    departmentBudget: 'Department Budget',
    
    // Project Estimator
    projectEstimator: 'Project Estimator',
    estimateProject: 'Estimate Project',
    projectName: 'Project Name',
    projectType: 'Project Type',
    projectDuration: 'Project Duration',
    teamSize: 'Team Size',
    complexity: 'Complexity',
    estimatedCost: 'Estimated Cost',
    estimatedTime: 'Estimated Time',
    riskFactor: 'Risk Factor',
    
    // Team Workload
    teamWorkload: 'Team Workload',
    workloadDistribution: 'Workload Distribution',
    teamMember: 'Team Member',
    assignedTasks: 'Assigned Tasks',
    completedTasks: 'Completed Tasks',
    workloadPercentage: 'Workload %',
    capacity: 'Capacity',
    utilization: 'Utilization',
    
    // Dashboard Overview
    systemOverview: 'System Overview',
    activeEmployees: 'Active Employees',
    visitorsToday: 'Visitors Today',
    activeSensors: 'Active Sensors',
    pendingTasks: 'Pending Tasks',
    systemStatus: 'System Status',
    recentActivity: 'Recent Activity',
    aiInsights: 'AI Insights',
    
    // Dashboard Stats
    employees: 'Employees',
    visitors: 'Visitors',
    sensors: 'Sensors',
    projects: 'Projects',
    access: 'Access',
    system: 'System',
    
    // Dashboard Metrics
    total: 'Total',
    active: 'Active',
    completed: 'Completed',
    overdue: 'Overdue',
    granted: 'Granted',
    denied: 'Denied',
    health: 'Health',
    uptime: 'Uptime',
    performance: 'Performance',
    
    // AI Insights
    growth: 'Growth',
    maintenance: 'Maintenance',
    suspiciousActivity: 'Suspicious Activity',
    overdueTasks: 'Overdue Tasks',
    sensorMaintenance: 'Sensor Maintenance',
    teamGrowth: 'Team Growth',
    
    // Actions
    viewEmployees: 'View Employees',
    viewVisitors: 'View Visitors',
    viewSensors: 'View Sensors',
    viewTasks: 'View Tasks',
    viewLogs: 'View Logs',
    reviewSensors: 'Review Sensors',
    
    // Time and Trends
    thisMonth: 'this month',
    thisWeek: 'this week',
    today: 'today',
    trend: 'trend',
    increase: 'increase',
    decrease: 'decrease',
    
    // Notifications
    tasksOverdue: '{count} tasks are overdue',
    sensorsNeedAttention: '{count} sensors require attention',
    accessDeniedIncrease: 'Increase in denied access attempts',
    teamGrowthPercent: 'Team has grown {percent}% this month',
    
    // Filters
    filterByStatus: 'Filter by Status',
    filterByPriority: 'Filter by Priority',
    filterByAssignee: 'Filter by Assignee',
    filterByProject: 'Filter by Project',
    all: 'All',
    
    // Charts and Analytics
    taskProgress: 'Task Progress',
    budgetAnalysis: 'Budget Analysis',
    workloadChart: 'Workload Chart',
    timeTracking: 'Time Tracking',
    costAnalysis: 'Cost Analysis',
    
    // Dashboard Overview Descriptions
    accessValidationDescription: 'Validar acceso de empleados con reconocimiento facial con IA',
    cameraManagementDescription: 'Gestionar cámaras UniFi y monitorear seguridad de la instalación',
    sensorAdoptionDescription: 'Monitorear y configurar sensores IoT en toda la instalación',
    roomDisplayManagerDescription: 'Gestionar displays de habitaciones y sistemas de información',
    taskManagementDescription: 'Seguir tareas, presupuestos y progreso de proyectos',
    databaseUpgradeDescription: 'Actualizar esquema de base de datos y migrar datos',
    
    // Additional Status
    onTrack: 'On Track',
    
    // Dashboard
    addWidget: 'Add Widget',
    editDashboard: 'Edit Dashboard',
    exitEditMode: 'Exit Edit Mode',
    selectWidget: 'Select Widget',
    selectWidgetDescription: 'Select a widget to add to your dashboard',
    allWidgetsAdded: 'All available widgets are already added to your dashboard',
    cancel: 'Cancel',
    update: 'Update',
    close: 'Close',
    
    // Modular Dashboard
    modularDashboard: 'Modular Dashboard',
    customizeDashboardDescription: 'Customize your control panel with interactive widgets',
    selectProject: 'Select Project',
    chooseProjectToViewData: 'Choose the project to view its data',
    myDashboard: 'My Dashboard',
    widgetsConfigured: '{count} widgets configured',
    widgetAddedSuccessfully: 'Widget added successfully',
    widgetRemovedSuccessfully: 'Widget removed successfully',
    widgetSettingsSaved: 'Widget settings saved',
    noWidgetsConfigured: 'No widgets configured',
    addWidgetsToCustomizeDashboard: 'Add widgets to customize your dashboard',
    addFirstWidget: 'Add First Widget',
    configureWidget: 'Configure Widget',
    widgetTitle: 'Widget Title',
    size: 'Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    configure: 'Configure',
    delete: 'Delete',
    save: 'Save',
    roomSensors: 'Room Sensors',
    
    // Widgets
    weatherAndTime: 'Weather & Time',
    roomInformation: 'Room Information',
    generalAnalysis: 'General Analysis',
    notifications: 'Notifications',
    settings: 'Settings',
    
    // Widget Descriptions
    roomSensorsDescription: 'Monitoreo en tiempo real de sensores de temperatura, humedad y ocupación',
    employeesDescription: 'Lista de empleados con información de contacto y estado',
    accessLogsDescription: 'Historial de entradas y salidas de empleados y visitantes',
    roomInformationDescription: 'Estado de conexiones WiFi, temperatura y ocupación por habitación',
    weatherDescription: 'Información meteorológica en tiempo real con selección de ciudad',
    analyticsDescription: 'Métricas y estadísticas generales del sistema',
    notificationsDescription: 'Alertas y notificaciones del sistema en tiempo real',
    settingsDescription: 'Configuración general del dashboard y preferencias',
    
    // Weather Widget
    humidity: 'Humidity',
    wind: 'Wind',
    visibility: 'Visibility',
    pressure: 'Pressure',
    feelsLike: 'Feels like',
    selectCityTimezone: 'Select City & Timezone',
    city: 'City',
    currentLocalTime: 'Current Local Time',
    
    // UniFi Widget
    status: 'Status',
    wifiSignal: 'WiFi Signal',
    connectedClients: 'Connected Clients',
    lastActivity: 'Last Activity',
    temperature: 'Temperature',
    detailsOf: 'Details of',
    clients: 'clients',
    
    // Analytics Widget
    totalEmployees: 'Total Employees',
    activeEmployees: 'Active Employees',
    rooms: 'Rooms',
    occupied: 'Occupied',
    energyConsumption: 'Energy Consumption',
    ofDailyConsumption: 'of daily consumption',
    securityAlerts: 'Security Alerts',
    activeAlerts: 'active alerts',
    
    // Notifications Widget
    unauthorizedAccessDetected: 'Unauthorized access detected at the main entrance',
    scheduledMaintenance: 'Scheduled maintenance for the climate control system',
    systemUpdateCompleted: 'System update completed successfully',
    energyConsumptionAbove: 'Energy consumption above average',
    
    // Settings Widget
    receiveRealTimeAlerts: 'Receive real-time alerts',
    updateDataAutomatically: 'Update data automatically',
    changeApplicationTheme: 'Change application theme',
    language: 'Language',
    timezone: 'Timezone',
    enabled: 'Enabled',
    disabled: 'Disabled',
    
    // Room Names
    conferenceRoomA: 'Conference Room A',
    mainOffice: 'Main Office',
    receptionArea: 'Reception Area',
    breakRoom: 'Break Room',
    
    // Weather Conditions
    sunny: 'Sunny',
    partlyCloudy: 'Partly Cloudy',
    cloudy: 'Cloudy',
    rainy: 'Rainy',
    clear: 'Clear',
    
    // Status
    online: 'online',
    offline: 'offline',
    
    // Priority Levels
    high: 'high',
    medium: 'medium',
    low: 'low',
    
    // Widget Development
    widgetInDevelopment: 'Widget "{type}" in development',
    
    // Common Actions
    refresh: 'Refresh',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    apply: 'Apply',
    reset: 'Reset',
    submit: 'Submit',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    
    // Time
    now: 'now',
    ago: 'ago',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    
    // Units
    celsius: '°C',
    fahrenheit: '°F',
    percent: '%',
    kmh: 'km/h',
    hpa: 'hPa',
    km: 'km',
    
    // Theme
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    
    // User Interface
    welcome: 'Welcome',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    
    // Form Validation
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    passwordMismatch: 'Passwords do not match',
    minLength: 'Minimum {length} characters required',
    
    // Success Messages
    savedSuccessfully: 'Saved successfully',
    updatedSuccessfully: 'Updated successfully',
    deletedSuccessfully: 'Deleted successfully',
    
    // Error Messages
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Please try again',
    networkError: 'Network error',
    
    // Confirmation
    areYouSure: 'Are you sure?',
    thisActionCannotBeUndone: 'This action cannot be undone',
    
    // Pagination
    showing: 'Showing',
    of: 'of',
    results: 'results',
    
    // Search
    noResultsFound: 'No results found',
    searchPlaceholder: 'Search...',
    
    // Filters
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    
    // Date/Time
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    thisYear: 'This Year',
    lastYear: 'Last Year',
    
    // Months
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    
    // Days
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    
    // --- Sensor Adoption & Room Display ---
    sensorAdoption: 'Sensor Adoption',
    sensorAdoptionDescription: 'Adopt and configure new sensors detected in your facility.',
    selectProject: 'Select Project',
    selectProjectForSensors: 'Choose a project to manage its sensors.',
    sensorDiscovery: 'Sensor Discovery',
    scanForNewSensors: 'Scan for new sensors in your facility.',
    scanning: 'Scanning...',
    startScan: 'Start Scan',
    scanningProgress: 'Scanning Progress',
    pendingSensors: 'Pending Sensors',
    sensorsWaiting: 'sensors waiting for adoption',
    noPendingSensors: 'No pending sensors found',
    startScanToDiscover: 'Start a scan to discover new sensors.',
    adopt: 'Adopt',
    adoptSensor: 'Adopt Sensor',
    sensorName: 'Sensor Name',
    enterSensorName: 'Enter a name for the sensor',
    sensorType: 'Sensor Type',
    temperatureSensor: 'Temperature Sensor',
    humiditySensor: 'Humidity Sensor',
    co2Sensor: 'CO₂ Sensor',
    soilMoistureSensor: 'Soil Moisture Sensor',
    unknownSensor: 'Unknown Sensor',
    assignToRoom: 'Assign to Room',
    location: 'Location',
    enterLocation: 'Enter location',
    description: 'Description',
    enterDescription: 'Enter a description',
    threshold: 'Threshold',
    enterThreshold: 'Enter threshold value',
    sensorDetails: 'Sensor Details',
    signalStrength: 'Signal Strength',
    batteryLevel: 'Battery Level',
    lastSeen: 'Last Seen',
    never: 'Never',
    new: 'New',
    viewDetails: 'View Details',
    sensorAdoptedSuccessfully: 'Sensor adopted successfully',
    errorAdoptingSensor: 'Error adopting sensor',
    errorFetchingProjects: 'Error fetching projects',
    errorFetchingRooms: 'Error fetching rooms',
    errorFetchingSensors: 'Error fetching sensors',
    scanCompleted: 'Scan completed',
    
    // --- Dashboard Specific ---
    dashboard: {
      title: 'Cultivation Dashboard',
      subtitle: 'Monitor and control your crops in real time',
      activeProjects: 'Active Projects',
      projectsInProgress: 'Projects in progress',
      configuredRooms: 'Configured Rooms',
      cultivationSpaces: 'Cultivation spaces',
      activeSensors: 'Active Sensors',
      monitoringDevices: 'Monitoring devices',
      pendingSensors: 'Pending Sensors',
      waitingConfiguration: 'Waiting for configuration',
      selectProject: 'Select Project',
      chooseProjectToView: 'Choose the project to view its data',
      cultivationSpaces: 'Cultivation Spaces',
      pendingSensorsTitle: 'Pending Sensors for Registration',
      configureNewSensors: 'Configure newly detected sensors',
      sensorId: 'Sensor ID',
      register: 'Register',
      registerSensor: 'Register Sensor',
      sensorName: 'Sensor Name',
      room: 'Room',
      selectRoomAndName: 'You must select a room and assign a name to the sensor',
      sensorRegistered: 'Sensor registered successfully',
      sensorRegistrationError: 'There was an error registering the sensor',
    },
    
    // --- Room Info ---
    roomInfo: {
      room: 'Room',
      roomInformation: 'Room Information',
      roomName: 'Room name',
      sensorOffline: 'Sensor Offline',
      noRecentMeasurements: 'No recent measurements found for this room',
      noSoilMoistureSensor: 'This room does not have a soil moisture sensor.',
      lastUpdate: 'Last update',
      cultivationProgress: 'Cultivation Progress',
      dayProgress: 'Day {current} of {total} ({percentage}%)',
      notConfigured: 'Not configured',
      maxTemperature: 'Maximum Temperature',
      minHumidity: 'Minimum Humidity',
      maxHumidity: 'Maximum Humidity',
      chartsOf: 'Charts of {type}',
    },
    
    // --- Login ---
    login: {
      welcome: 'Welcome',
      signInToAccount: 'Sign in to your account',
      email: 'Email',
      password: 'Password',
      signIn: 'Sign In',
      signingIn: 'Signing In...',
      noAccount: "Don't have an account?",
      registerHere: 'Register here',
      invalidServerResponse: 'Invalid server response',
      connectionError: 'Connection error. Please try again.',
    },
    
    // --- Register ---
    register: {
      createAccount: 'Create an Account',
      registerToAccess: 'Register to access',
      email: 'Email',
      password: 'Password',
      register: 'Register',
      alreadyHaveAccount: 'Already have an account? Sign in',
      registrationError: 'Registration error',
    },
    
    // --- Navbar ---
    navbar: {
      createProject: 'Create Project',
      createRoom: 'Create Room',
      dashboard: 'Dashboard',
      profile: 'Profile',
      logOut: 'Log Out',
    },
    
    // --- Side Menu ---
    sideMenu: {
      home: 'Home',
      modularDashboard: 'Modular Dashboard',
      grow: 'Grow',
      createProject: 'Create Project',
      createRoom: 'Create Room',
      roomControl: 'Room Control',
      projectSettings: 'Project Settings',
      sensorSettings: 'Sensor Settings',
      automationSettings: 'Automation Settings',
      harvested: 'Harvested',
      user: 'User',
      profile: 'Profile',
      userProfile: 'User Profile',
      admin: 'Admin',
      adminPage: 'Admin Page',
      facility: 'Facility',
      employments: 'Employments',
      visitors: 'Visitors',
      accessLogs: 'Access Logs',
      accessValidation: 'Access Validation',
      logOut: 'Log Out',
    },
    
    // --- UniFi Control ---
    unifiControl: {
      title: 'Centro de Control UniFi',
      subtitle: 'Gestiona tu sistema UniFi de forma centralizada',
      connected: 'Connected',
      disconnected: 'Disconnected',
      connectionError: 'Error de Conexión',
      notConfigured: 'No Configurado',
      checking: 'Verificando...',
      unknown: 'Desconocido',
      setupRequired: 'Configuración UniFi Requerida',
      setupDescription: 'Configura la conexión con tu Controlador UniFi para comenzar a gestionar tus dispositivos.',
      startSetup: 'Iniciar Configuración',
      refreshStatus: 'Actualizar Estado',
      setup: 'Configuración',
      retry: 'Reintentar',
      connectionErrorMsg: 'Error de conexión con UniFi. Verifique la configuración.',
      connecting: 'Conectando con UniFi...',
      accessControl: 'Control de Acceso',
      cameraManagement: 'Gestión de Cámaras',
      employeeIntegration: 'Integración de Empleados',
      settings: 'Configuración',
      accessDevices: 'Dispositivos de Acceso',
      cameras: 'Cámaras',
      networkDevices: 'Dispositivos de Red',
      systemOnline: 'Sistema Online',
      systemOffline: 'Sistema Offline',
    },
    
    // --- UniFi Setup ---
    unifiSetup: {
      connectionType: 'Connection Type',
      wizardTitle: 'UniFi Setup Wizard',
      connectionSetup: 'Connection Setup',
      authentication: 'Authentication',
      siteSelection: 'Site Selection',
      deviceDiscovery: 'Device Discovery',
      testConnection: 'Test Connection',
      complete: 'Complete',
      connectionInfo: 'UniFi Controller Connection',
      connectionDescription: 'Enter your UniFi Controller connection details',
      controllerHost: 'Controller Host',
      hostHelper: 'IP address or hostname of your UniFi Controller',
      controllerPort: 'Controller Port',
      portHelper: 'Usually 443 for HTTPS',
      authenticationInfo: 'Authentication',
      authWarning: 'Your credentials will be stored locally and used to connect to the UniFi API',
      username: 'Username',
      password: 'Password',
      siteSelectionInfo: 'Site Selection',
      selectSite: 'Select Site',
      defaultSite: 'Default Site',
      siteDescription: 'Choose the UniFi site you want to manage',
      deviceDiscoveryInfo: 'Device Discovery',
      discoverDevices: 'Discover Devices',
      discovering: 'Discovering...',
      networkDevices: 'Network Devices',
      networkDevicesFound: 'Access points, switches, gateways',
      accessDevices: 'Access Devices',
      accessDevicesFound: 'Door locks, access readers',
      protectCameras: 'Protect Cameras',
      protectCamerasFound: 'Security cameras',
      testConnectionInfo: 'Test Connection',
      testConnection: 'Test Connection',
      testing: 'Testing...',
      connectionTest: 'Connection',
      authenticationTest: 'Authentication',
      sitesTest: 'Sites',
      connectionSuccess: 'Connection successful',
      authSuccess: 'Authentication successful',
      setupComplete: 'Setup Complete',
      setupSuccess: 'UniFi integration has been configured successfully!',
      configurationSummary: 'Configuration Summary',
      controller: 'Controller',
      site: 'Site',
      finish: 'Finish',
      apiKey: 'API Key',
      apiKeyHelper: 'Get your API key from UniFi Cloud dashboard',
      cloudSetup: 'UniFi Cloud Setup',
      controllerSetup: 'UniFi Controller Setup',
      chooseConnectionType: 'Choose UniFi Connection Type',
      cloudDescription: 'Connect using API key (Recommended)',
      controllerDescription: 'Connect to local or hosted controller',
      apiKeyRequired: 'Please enter your UniFi Cloud API key',
      fillRequiredFields: 'Please fill in all required fields',
    },
    
    accessLogs: {
      title: 'Access Logs',
      subtitle: 'Monitor and manage employee and visitor access',
      totalEntries: 'Total Entries',
      employees: 'Employees',
      visitors: 'Visitors',
      onTime: 'On Time',
      late: 'Late',
      effectiveHours: 'Effective Hours',
      breakViolations: 'Break Violations (min)',
      filtersAndSearch: 'Filters & Search',
      filtersAndSearchSubtitle: 'Search and filter access records',
      searchPlaceholder: 'Search by name or email...',
      type: 'Type',
      all: 'All',
      status: 'Status',
      hideFilters: 'Hide',
      moreFilters: 'More Filters',
      clear: 'Clear',
      advancedFilters: 'Advanced filters:',
      startDate: 'Start Date',
      endDate: 'End Date',
      applyFilters: 'Apply Filters',
      showOnly1000: 'Show only 1000 entries',
      showAllEntries: 'Show all entries',
      refresh: 'Refresh',
      exportFilteredExcel: 'Export filtered data (Excel)',
      exportAllExcel: 'Export all data (Excel)',
      accessLogsTitle: 'Access Records',
      showing: 'Showing',
      of: 'of',
      records: 'records',
      user: 'User',
      date: 'Date',
      entryTime: 'Entry',
      exitTime: 'Exit',
      totalHoursWorked: 'Total Hours Worked',
      actions: 'Actions',
      rowsPerPage: 'Rows per page:',
      justifyLateEntry: 'Justify Late Entry',
      justification: 'Justification for delay',
      justificationPlaceholder: 'Describe the reason for the delay...',
      cancel: 'Cancel',
      submitJustification: 'Submit Justification',
    },
    
    employments: {
      title: 'Employee Management',
      subtitle: 'Manage your company employees and their access credentials',
      totalEmployees: 'Total Employees',
      registeredEmployees: 'Registered employees',
      activeEmployees: 'Active Employees',
      withActiveAccess: 'With active access',
      withCredentials: 'With Credentials',
      withRfidAssigned: 'With RFID assigned',
      withoutCredentials: 'Without Credentials',
      actions: 'Actions',
      manageEmployees: 'Manage employee information',
      addEmployee: 'Add Employee',
      customizeBadges: 'Customize Badges',
      employeesList: 'Employees List',
      showing: 'Showing',
      employees: 'employees',
      employee: 'Employee',
      position: 'Position',
      phone: 'Phone',
      schedule: 'Schedule',
      workDays: 'Work Days',
      credentials: 'Credentials',
      withCredential: 'With Credential',
      withoutCredential: 'Without Credential',
      viewCredential: 'View credential',
      editEmployee: 'Edit Employee',
      deleteEmployee: 'Delete Employee',
      credential: 'Employee Credential',
      close: 'Close',
      print: 'Print',
      addNewEmployee: 'Add New Employee',
      fullName: 'Full Name',
      email: 'Email',
      rfidCode: 'RFID Code',
      daysPerWeek: 'days/week',
      uploadPhoto: 'Upload Photo',
      selectPhoto: 'Select Photo',
      selectedFile: 'Selected file:',
      cancel: 'Cancel',
      saving: 'Saving...',
      update: 'Update',
      save: 'Save',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      logoSize: 'Logo Size',
      photoSize: 'Photo Size',
      qrSize: 'QR Size',
      saveCustomization: 'Save Customization',
      customizationSaved: 'Customization saved successfully',
      customizationError: 'Error saving customization',
    },
    
    visitors: {
      title: 'Visitor Management',
      subtitle: 'Manage visitor registration and control in your facility',
      totalVisitors: 'Total Visitors',
      registeredInSystem: 'Registered in system',
      today: 'Today',
      todayVisitors: 'Today visitors',
      thisWeek: 'This Week',
      last7Days: 'Last 7 days',
      thisMonth: 'This Month',
      monthVisitors: 'Month visitors',
      actions: 'Actions',
      manageVisitors: 'Manage visitors',
      addVisitor: 'Add Visitor',
      visitorsList: 'Visitors List',
      showing: 'Showing',
      visitors: 'visitors',
      visitor: 'Visitor',
      identification: 'Identification',
      visitReason: 'Visit Reason',
      visitDate: 'Visit Date',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      identificationNumber: 'Identification Number',
      cancel: 'Cancel',
      save: 'Save',
    },
    
    employeeAccess: {
      title: 'Employee Access',
      subtitle: 'Access control and time tracking for employees',
      selectAccessMethod: 'Select your access method',
      chooseYourAccessMethod: 'Choose how you want to access the system',
      qrCode: 'QR Code',
      phone: 'Phone',
      scanQrCodeToAccess: 'Scan your QR code to access the system',
      activateQrScanner: 'Activate QR Scanner',
      qrScannerActive: 'QR Scanner Active',
      phoneVerification: 'Phone Verification',
      enterLast4Digits: 'Enter the last 4 digits of your phone number',
      last4Digits: 'Last 4 digits',
      onlyNumbers0to9: 'Only numbers 0-9',
      selectAction: 'Select an action',
      chooseYourAction: 'Choose what you want to do',
      startBreak1: 'Start Break 1',
      endBreak1: 'End Break 1',
      startBreak2: 'Start Break 2',
      endBreak2: 'End Break 2',
      startBreak3: 'Start Break 3',
      endBreak3: 'End Break 3',
      employeeVerified: 'Employee Verified',
      prepareForCapture: 'Prepare for facial capture...',
      newAccess: 'New Access',
    },
    
    accessValidation: {
      title: 'Validación de Acceso',
      subtitle: 'Revisar y gestionar solicitudes de acceso',
      totalRequests: 'Total de Solicitudes',
      pendingRequests: 'Solicitudes pendientes',
      approved: 'Aprobadas',
      approvedRequests: 'Solicitudes aprobadas',
      rejected: 'Rechazadas',
      rejectedRequests: 'Solicitudes rechazadas',
      pending: 'Pendiente',
      awaitingReview: 'En espera de revisión',
      accessRequests: 'Solicitudes de Acceso',
      showing: 'Mostrando',
      requests: 'solicitudes',
      requester: 'Solicitante',
      requestType: 'Tipo de Solicitud',
      requestDate: 'Fecha de Solicitud',
      status: 'Estado',
      actions: 'Acciones',
      viewDetails: 'Ver Detalles',
      approve: 'Aprobar',
      reject: 'Rechazar',
      requestDetails: 'Detalles de la Solicitud',
      email: 'Correo Electrónico',
      reason: 'Motivo',
      additionalInfo: 'Información Adicional',
      noAdditionalInfo: 'No se proporcionó información adicional',
      close: 'Cerrar',
      requestApproved: 'Solicitud aprobada exitosamente',
      requestRejected: 'Solicitud rechazada exitosamente',
      errorApproving: 'Error approving request',
      errorRejecting: 'Error rejecting request',
    },
    
    printableCard: {
      companyLogo: 'Logo de la Empresa',
      schedule: 'Horario',
      workDays: 'Días de Trabajo',
    },
    
    userProfile: {
      title: 'Perfil de Usuario',
      subtitle: 'Gestiona tu información personal y configuraciones',
      profileInformation: 'Información del Perfil',
      managePersonalInfo: 'Actualiza tus datos personales',
      changeAvatar: 'Cambiar Avatar',
      newEmail: 'Nuevo email',
      enterNewEmail: 'Ingrese nuevo correo',
      newPassword: 'Nueva contraseña',
      enterNewPassword: 'Ingrese nueva contraseña',
      saveChanges: 'Guardar Cambios',
      profileUpdated: 'Perfil actualizado correctamente!',
      updateError: 'Error al actualizar el perfil',
      sendInvitation: 'Enviar Invitación',
      inviteNewUser: 'Comparte proyectos con otros usuarios',
      selectProject: 'Seleccionar Proyecto',
      invitationEmail: 'Email del usuario',
      enterInvitationEmail: 'Correo del usuario',
      selectProjectFirst: 'Por favor, selecciona un proyecto antes de enviar la invitación.',
      invitationSent: 'Invitación enviada!',
      invitationError: 'Error al enviar la invitación',
      invitationsSent: 'Invitaciones Enviadas',
      sentInvitationsHistory: 'Historial de invitaciones a proyectos',
      invitedEmail: 'Email Invitado',
      project: 'Proyecto',
      status: 'Estado',
      date: 'Fecha',
    },
    
    roomLandingPage: {
      room: 'Room',
      lastUpdate: 'Last update',
      currentConditions: 'Current Conditions',
      sensorsOffline: 'Sensors Offline',
      noRecentMeasurements: 'No recent measurements found',
      temperature: 'Temperature',
      humidity: 'Humidity',
      co2: 'CO₂',
      soilMoisture: 'Soil Moisture',
      equipmentStatus: 'Equipment Status',
      lighting: 'Lighting',
      on: 'ON',
      off: 'OFF',
      noConfiguration: 'Not configured',
      airConditioner: 'Air Conditioner',
      humidifier: 'Humidifier',
      dehumidifier: 'Dehumidifier',
      max: 'Max',
      min: 'Min',
      na: 'N/A',
      cultivationProgress: 'Cultivation Progress',
      day: 'Day',
      of: 'of',
      readyToHarvest: 'Ready to harvest!',
      floweringPhase: 'Flowering Phase',
      growthPhase: 'Growth Phase',
      germinationPhase: 'Germination Phase',
      progress: 'Progress',
      harvestDate: 'Harvest Date',
      daysRemaining: 'days remaining',
      roomConfiguration: 'Room Configuration',
      equipmentConfiguration: 'Equipment Configuration',
      maxTemperature: 'Maximum Temperature (A/C)',
      minHumidity: 'Minimum Humidity (Humidifier)',
      maxHumidity: 'Maximum Humidity (Dehumidifier)',
      cultivationStartDate: 'Cultivation Start Date',
      lightScheduleStart: 'Light Schedule Start',
      lightScheduleEnd: 'Light Schedule End',
      cancel: 'Cancel',
      saveConfiguration: 'Save Configuration',
    },
    
    roomControl: {
      title: 'Room Control',
      subtitle: 'Configure and control your cultivation space parameters',
      projectAndRoomSelection: 'Project and Room Selection',
      selectProjectAndRoom: 'Choose the project and room to configure',
      selectProject: 'Select Project',
      selectRoom: 'Select Room',
      basicConfiguration: 'Basic Configuration',
      cultivationParameters: 'General cultivation parameters',
      cultivationDuration: 'Cultivation Duration (weeks)',
      cultivationStartDate: 'Cultivation Start Date',
      lightingSchedule: 'Lighting Schedule',
      lightScheduleDescription: 'Configure light schedules',
      lightStartTime: 'Light Start Time',
      lightEndTime: 'Light End Time',
      temperatureRange: 'Temperature Range',
      optimalTemperatureRange: 'Optimal temperature range',
      minTemperature: 'Minimum (°C)',
      maxTemperature: 'Maximum (°C)',
      humidityRange: 'Humidity Range',
      optimalHumidityRange: 'Optimal humidity range',
      minHumidity: 'Minimum (%)',
      maxHumidity: 'Maximum (%)',
      plantVarieties: 'Plant Varieties',
      cultivationVarieties: 'Configure varieties and quantities',
      variety: 'Variety',
      count: 'Count',
      addVariety: 'Add Variety',
      relayConfiguration: 'Relay Configuration',
      automaticDeviceControl: 'Automatic device control',
      relay: 'Relay',
      relayName: 'Relay Name',
      relayType: 'Relay Type',
      light: 'Light',
      fan: 'Fan',
      pump: 'Pump',
      heater: 'Heater',
      cooler: 'Cooler',
      enabled: 'Enabled',
      relayThreshold: 'Threshold',
      saveRoomConfig: 'Save Room Configuration',
      saveRelayConfig: 'Save Relay Configuration',
      roomConfigSaved: 'Room configuration saved successfully',
      roomConfigError: 'Error saving room configuration',
      relayConfigSaved: 'Relay configuration saved successfully',
      relayConfigError: 'Error saving relay configuration',
      cultivationRestarted: 'Cultivation restarted successfully',
      cultivationRestartError: 'Error restarting cultivation cycle',
    },
    
    roomDisplayManager: {
      title: 'Room Display Management',
      subtitle: 'Configure and manage display screens for each room',
      roomsList: 'Project Rooms',
      showing: 'Showing',
      rooms: 'rooms',
      room: 'Room',
      project: 'Project',
      status: 'Status',
      lastUpdate: 'Last Update',
      configuration: 'Configuration',
      actions: 'Actions',
      noDescription: 'No description',
      noProject: 'No project',
      active: 'Active',
      inactive: 'Inactive',
      never: 'Never',
      configured: 'Configured',
      notConfigured: 'Not configured',
      editConfiguration: 'Edit Configuration',
      viewDisplay: 'View Display',
      deleteRoom: 'Delete Room',
      configureDisplay: 'Configure Display',
      enableDisplay: 'Enable Display',
      displayPassword: 'Display Password (optional)',
      passwordHelper: 'Leave empty for password-free access',
      updateInterval: 'Update Interval (seconds)',
      showSettingsButton: 'Show Settings Button',
      showEquipment: 'Show Equipment Status',
      showProgress: 'Show Cultivation Progress',
      customMessage: 'Custom Message',
      customMessageHelper: 'Message that will be displayed on the room display',
      cancel: 'Cancel',
      saveConfiguration: 'Save Configuration',
      configUpdated: 'Display configuration updated',
      configError: 'Error saving configuration',
      confirmDelete: 'Are you sure you want to delete this room?',
      roomDeleted: 'Room deleted successfully',
      deleteError: 'Error deleting room',
      displayToggled: 'Display toggled',
      displayToggleError: 'Error toggling display status',
      urlCopied: 'URL copied to clipboard',
      roomCreated: 'Room created successfully',
      roomName: 'Room Name',
      theme: 'Theme',
      defaultTheme: 'Default',
      darkTheme: 'Dark',
      lightTheme: 'Light',
      greenhouseTheme: 'Greenhouse',
      displayOptions: 'Display Options',
      protected: 'Protected',
      copyUrl: 'Copy URL',
      close: 'Close',
    },
    
    sensorChart: {
      title: 'Sensor Data Chart',
      visualizationMode: 'Visualization Mode',
      averageMode: 'Room Average',
      sensorMode: 'Sensor Data',
      recentValues: 'Recent Values with Circles',
      dataChart: 'Data Chart',
      lastHour: 'Last Hour',
      lastHours: 'Last {hours} Hours',
      temperature: 'Temperature',
      humidity: 'Humidity',
      co2: 'CO₂',
      soilMoisture: 'Soil Moisture',
    },
    
    sensorStatusPage: {
      title: 'Sensor Status',
      subtitle: 'Monitor and configure the status of all project sensors',
      totalSensors: 'Total Sensors',
      onlineSensors: 'Online Sensors',
      offlineSensors: 'Offline Sensors',
      maintenance: 'Maintenance',
      online: 'Online',
      working: 'Working',
      disconnected: 'Disconnected',
      requiresAttention: 'Requires attention',
      sensorConfiguration: 'Sensor Configuration',
      manageSensorConfiguration: 'Manage the configuration of each sensor',
      sensor: 'Sensor',
      room: 'Room',
      type: 'Type',
      status: 'Status',
      lastReading: 'Last Reading',
      actions: 'Actions',
      noRoom: 'No room',
      noData: 'No data',
      viewDetails: 'View Details',
      editSensor: 'Edit Sensor',
      deleteSensor: 'Delete Sensor',
      temperature: 'Temperature',
      humidity: 'Humidity',
      co2: 'CO₂',
      soilMoisture: 'Soil Moisture',
      connected: 'Connected',
      disconnected: 'Disconnected',
      maintenance: 'Maintenance',
    },
    
    projectSettings: {
      title: 'Project Settings',
      subtitle: 'Customize your project configuration',
      temperatureUnit: 'Temperature Unit',
      measurementScale: 'Measurement scale',
      location: 'Location',
      projectLocation: 'Project location',
      noConfigured: 'Not configured',
      roomsConfigured: 'Configured Rooms',
      cultivationSpaces: 'Cultivation spaces',
      status: 'Status',
      active: 'Active',
      projectInOperation: 'Project in operation',
      generalConfiguration: 'General Configuration',
      adjustBasicParameters: 'Adjust basic project parameters',
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      locationPlaceholder: 'Enter project location',
      saveConfiguration: 'Save Configuration',
      addNewRoom: 'Add New Room',
      createCultivationSpace: 'Create a new cultivation space',
      roomName: 'Room Name',
      roomNamePlaceholder: 'Enter room name',
      addRoom: 'Add Room',
      roomManagement: 'Room Management',
      manageProjectRooms: 'Manage project cultivation spaces',
      room: 'Room',
      lastUpdate: 'Last Update',
      actions: 'Actions',
      noDescription: 'No description',
      never: 'Never',
      editRoom: 'Edit Room',
      deleteRoom: 'Delete Room',
      noRoomsAssociated: 'No rooms associated with this project',
      createFirstRoom: 'Create your first room using the form above',
      confirmDeletion: 'Confirm Deletion',
      confirmDeleteRoom: 'Are you sure you want to delete the room',
      deleteWarning: 'This action cannot be undone and will delete all associated data',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    
    onTrack: 'On Track',
    
    // Task List
    noTasksFound: 'No tasks found',
    createFirstTask: 'Create your first task to get started',
    progress: 'Progress',
    hours: 'Hours',
    logTime: 'Log Time',
  },
  
  es: {
    // Navigation
    dashboard: 'Dashboard',
    employees: 'Empleados',
    visitors: 'Visitantes',
    accessLogs: 'Registros de Acceso',
    unifiControl: 'Control UniFi',
    sensors: 'Sensores',
    automation: 'Automatización',
    configuration: 'Configuración',
    branding: 'Marca',
    profile: 'Perfil',
    harvest: 'Cosecha',
    roomControl: 'Control de Habitaciones',
    administration: 'Administración',
    
    // --- UniFi Control ---
    unifiControl: {
      title: 'Control UniFi',
      subtitle: 'Gestiona dispositivos UniFi Network, Access y Protect',
      connected: 'Conectado',
      disconnected: 'Desconectado',
      connectionError: 'Error de Conexión',
      notConfigured: 'No Configurado',
      checking: 'Verificando...',
      unknown: 'Desconocido',
      setupRequired: 'Configuración Requerida',
      setupDescription: 'Necesitas configurar la conexión UniFi antes de usar esta función',
      startSetup: 'Iniciar Configuración',
      accessControl: 'Control de Acceso',
      cameraManagement: 'Gestión de Cámaras',
      employeeIntegration: 'Integración de Empleados',
      settings: 'Configuración',
    },
    
    // --- UniFi Setup ---
    unifiSetup: {
      connectionType: 'Tipo de Conexión',
      wizardTitle: 'Asistente de Configuración UniFi',
      connectionSetup: 'Configuración de Conexión',
      authentication: 'Autenticación',
      siteSelection: 'Selección de Sitio',
      deviceDiscovery: 'Descubrimiento de Dispositivos',
      testConnection: 'Probar Conexión',
      complete: 'Completar',
      connectionInfo: 'Conexión del Controlador UniFi',
      connectionDescription: 'Ingresa los detalles de conexión de tu Controlador UniFi',
      controllerHost: 'Host del Controlador',
      hostHelper: 'Dirección IP o nombre de host de tu Controlador UniFi',
      controllerPort: 'Puerto del Controlador',
      portHelper: 'Usualmente 443 para HTTPS',
      authenticationInfo: 'Autenticación',
      authWarning: 'Tus credenciales se almacenarán localmente y se usarán para conectar con la API de UniFi',
      username: 'Nombre de Usuario',
      password: 'Contraseña',
      siteSelectionInfo: 'Selección de Sitio',
      selectSite: 'Seleccionar Sitio',
      defaultSite: 'Sitio Predeterminado',
      siteDescription: 'Elige el sitio UniFi que quieres gestionar',
      deviceDiscoveryInfo: 'Descubrimiento de Dispositivos',
      discoverDevices: 'Descubrir Dispositivos',
      discovering: 'Descubriendo...',
      networkDevices: 'Dispositivos de Red',
      networkDevicesFound: 'Puntos de acceso, switches, gateways',
      accessDevices: 'Dispositivos de Acceso',
      accessDevicesFound: 'Cerraduras de puerta, lectores de acceso',
      protectCameras: 'Cámaras Protect',
      protectCamerasFound: 'Cámaras de seguridad',
      testConnectionInfo: 'Probar Conexión',
      testConnection: 'Probar Conexión',
      testing: 'Probando...',
      connectionTest: 'Conexión',
      authenticationTest: 'Autenticación',
      sitesTest: 'Sitios',
      connectionSuccess: 'Conexión exitosa',
      authSuccess: 'Autenticación exitosa',
      setupComplete: 'Configuración Completada',
      setupSuccess: '¡La integración UniFi ha sido configurada exitosamente!',
      configurationSummary: 'Resumen de Configuración',
      controller: 'Controlador',
      site: 'Sitio',
      finish: 'Finalizar',
      apiKey: 'Clave API',
      apiKeyHelper: 'Obtén tu clave API desde el panel de UniFi Cloud',
      cloudSetup: 'Configuración UniFi Cloud',
      controllerSetup: 'Configuración Controlador UniFi',
      chooseConnectionType: 'Elegir Tipo de Conexión UniFi',
      cloudDescription: 'Conectar usando clave API (Recomendado)',
      controllerDescription: 'Conectar a controlador local o alojado',
      apiKeyRequired: 'Por favor ingrese su clave API de UniFi Cloud',
      fillRequiredFields: 'Por favor complete todos los campos requeridos',
    },
    
    // --- Room Display ---
    roomDisplay: {
      title: 'Display de Habitación',
      subtitle: 'Información en tiempo real de la habitación',
      room: 'Habitación',
      temperature: 'Temperatura',
      humidity: 'Humedad',
      co2: 'CO₂',
      soilMoisture: 'Humedad del Suelo',
      lastUpdate: 'Última Actualización',
      noData: 'Sin datos',
      settings: 'Configuración',
      close: 'Cerrar',
    },
    
    // --- Room Display Manager ---
    roomDisplayManager: {
      title: 'Gestión de Displays de Rooms',
      subtitle: 'Configura y gestiona las pantallas de display para cada room',
      roomsList: 'Rooms del Proyecto',
      showing: 'Mostrando',
      rooms: 'habitaciones',
      room: 'Habitación',
      project: 'Proyecto',
      status: 'Estado',
      lastUpdate: 'Última Actualización',
      configuration: 'Configuración',
      actions: 'Acciones',
      noDescription: 'Sin descripción',
      noProject: 'Sin proyecto',
      active: 'Activo',
      inactive: 'Inactivo',
      never: 'Nunca',
      configured: 'Configurado',
      notConfigured: 'No configurado',
      editConfiguration: 'Editar Configuración',
      viewDisplay: 'Ver Display',
      deleteRoom: 'Eliminar Room',
      configureDisplay: 'Configurar Display',
      enableDisplay: 'Habilitar Display',
      displayPassword: 'Contraseña de Display (opcional)',
      passwordHelper: 'Dejar vacío para acceso sin contraseña',
      updateInterval: 'Intervalo de Actualización (segundos)',
      showSettingsButton: 'Mostrar Botón de Configuración',
      showEquipment: 'Mostrar Estado de Equipos',
      showProgress: 'Mostrar Progreso de Cultivo',
      customMessage: 'Mensaje Personalizado',
      customMessageHelper: 'Mensaje que se mostrará en el display del room',
      cancel: 'Cancelar',
      saveConfiguration: 'Guardar Configuración',
      configUpdated: 'Configuración de display actualizada',
      configError: 'Error al guardar la configuración',
      confirmDelete: '¿Estás seguro de que quieres eliminar este room?',
      roomDeleted: 'Room eliminado exitosamente',
      deleteError: 'Error al eliminar el room',
      displayToggled: 'Display activado/desactivado',
      displayToggleError: 'Error al cambiar el estado del display',
      urlCopied: 'URL copiada al portapapeles',
      roomCreated: 'Room creado exitosamente',
      roomName: 'Nombre del Room',
      theme: 'Tema',
      defaultTheme: 'Predeterminado',
      darkTheme: 'Oscuro',
      lightTheme: 'Claro',
      greenhouseTheme: 'Invernadero',
      displayOptions: 'Opciones de Display',
      protected: 'Protegido',
      copyUrl: 'Copiar URL',
      close: 'Cerrar',
    },
    
    // --- Sensor Chart ---
    sensorChart: {
      title: 'Gráfico de Datos de Sensores',
      visualizationMode: 'Modo de Visualización',
      averageMode: 'Promedio del Room',
      sensorMode: 'Datos del Sensor',
      recentValues: 'Indicadores de valores recientes con círculos',
      dataChart: 'Gráfica de datos',
      lastHour: 'Última Hora',
      lastHours: 'Últimas {hours} Horas',
      temperature: 'Temperatura',
      humidity: 'Humedad',
      co2: 'CO₂',
      soilMoisture: 'Humedad del Suelo',
    },
    
    // --- Sensor Status Page ---
    sensorStatusPage: {
      title: 'Estado de Sensores',
      subtitle: 'Monitorea y configura el estado de todos los sensores del proyecto',
      totalSensors: 'Total Sensores',
      onlineSensors: 'Sensores Conectados',
      offlineSensors: 'Sensores Desconectados',
      maintenance: 'Mantenimiento',
      online: 'En línea',
      working: 'Funcionando',
      disconnected: 'Desconectado',
      requiresAttention: 'Requiere atención',
      sensorConfiguration: 'Configuración de Sensores',
      manageSensorConfiguration: 'Gestiona la configuración de cada sensor',
      sensor: 'Sensor',
      room: 'Habitación',
      type: 'Tipo',
      status: 'Estado',
      lastReading: 'Última Lectura',
      actions: 'Acciones',
      noRoom: 'Sin habitación',
      noData: 'Sin datos',
      viewDetails: 'Ver Detalles',
      editSensor: 'Editar Sensor',
      deleteSensor: 'Eliminar Sensor',
      temperature: 'Temperatura',
      humidity: 'Humedad',
      co2: 'CO₂',
      soilMoisture: 'Humedad del Suelo',
      connected: 'Conectado',
      disconnected: 'Disconectado',
      maintenance: 'Mantenimiento',
    },
    
    // --- Project Settings ---
    projectSettings: {
      title: 'Configuración del Proyecto',
      subtitle: 'Personaliza la configuración de tu proyecto',
      temperatureUnit: 'Unidad de Temperatura',
      measurementScale: 'Escala de medición',
      location: 'Ubicación',
      projectLocation: 'Localización del proyecto',
      noConfigured: 'No configurada',
      roomsConfigured: 'Rooms Configuradas',
      cultivationSpaces: 'Espacios de cultivo',
      status: 'Estado',
      active: 'Activo',
      projectInOperation: 'Proyecto en funcionamiento',
      generalConfiguration: 'Configuración General',
      adjustBasicParameters: 'Ajusta los parámetros básicos del proyecto',
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      locationPlaceholder: 'Ingresa la ubicación del proyecto',
      saveConfiguration: 'Guardar Configuración',
      addNewRoom: 'Agregar Nueva Room',
      createCultivationSpace: 'Crea un nuevo espacio de cultivo',
      roomName: 'Nombre de la Room',
      roomNamePlaceholder: 'Ingresa el nombre de la room',
      addRoom: 'Agregar Room',
      roomManagement: 'Gestión de Rooms',
      manageProjectRooms: 'Gestiona los espacios de cultivo del proyecto',
      room: 'Room',
      lastUpdate: 'Última Actualización',
      actions: 'Acciones',
      noDescription: 'Sin descripción',
      never: 'Nunca',
      editRoom: 'Editar Room',
      deleteRoom: 'Eliminar Room',
      noRoomsAssociated: 'No hay rooms asociadas a este proyecto',
      createFirstRoom: 'Crea tu primera room usando el formulario de arriba',
      confirmDeletion: 'Confirmar Eliminación',
      confirmDeleteRoom: '¿Estás seguro de que quieres eliminar la room',
      deleteWarning: 'Esta acción no se puede deshacer y eliminará todos los datos asociados',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },
    
    // --- Access Logs ---
    accessLogs: {
      title: 'Registros de Acceso',
      subtitle: 'Historial completo de entradas y salidas',
      onTime: 'A Tiempo',
      late: 'Retrasos',
      effectiveHours: 'Horas Efectivas',
      breakViolations: 'Violaciones (min)',
      filtersAndSearch: 'Filtros y Búsqueda',
      filtersAndSearchSubtitle: 'Busca y filtra los registros de acceso',
      searchPlaceholder: 'Buscar por nombre o email...',
      type: 'Tipo',
      all: 'Todos',
      status: 'Estado',
      hideFilters: 'Ocultar',
      moreFilters: 'Más Filtros',
      clear: 'Limpiar',
      advancedFilters: 'Filtros avanzados:',
      startDate: 'Fecha Inicio',
      endDate: 'Fecha Fin',
      applyFilters: 'Aplicar Filtros',
      showOnly1000: 'Mostrar solo 1000 entradas',
      showAllEntries: 'Mostrar todas las entradas',
      refresh: 'Actualizar',
      exportFilteredExcel: 'Exportar datos filtrados (Excel)',
      exportAllExcel: 'Exportar todos los datos (Excel)',
      accessLogsTitle: 'Registros de Acceso',
      showing: 'Mostrando',
      of: 'de',
      records: 'registros',
      user: 'Usuario',
      date: 'Fecha',
      entryTime: 'Entrada',
      exitTime: 'Salida',
      totalHoursWorked: 'Horas Trabajadas',
      actions: 'Acciones',
      rowsPerPage: 'Filas por página:',
      justifyLateEntry: 'Justificar Retraso',
      justification: 'Justificación del retraso',
      justificationPlaceholder: 'Describe la razón del retraso...',
      cancel: 'Cancelar',
      submitJustification: 'Enviar Justificación',
    },
    
    // --- Employments ---
    employments: {
      title: 'Gestión de Empleados',
      subtitle: 'Administra los empleados de tu empresa y sus credenciales de acceso',
      totalEmployees: 'Total Empleados',
      registeredEmployees: 'Empleados registrados',
      activeEmployees: 'Empleados Activos',
      withActiveAccess: 'Con acceso activo',
      withCredentials: 'Con Credenciales',
      withRfidAssigned: 'Con RFID asignado',
      withoutCredentials: 'Sin Credenciales',
      actions: 'Acciones',
      manageEmployees: 'Gestiona la información de tus empleados',
      addEmployee: 'Agregar Empleado',
      customizeBadges: 'Personalizar Credenciales',
      employeesList: 'Lista de Empleados',
      showing: 'Mostrando',
      employees: 'empleados',
      employee: 'Empleado',
      position: 'Posición',
      phone: 'Teléfono',
      schedule: 'Horario',
      workDays: 'Días de Trabajo',
      credentials: 'Credenciales',
      withCredential: 'Con Credencial',
      withoutCredential: 'Sin Credencial',
      viewCredential: 'Ver credencial',
      editEmployee: 'Editar Empleado',
      deleteEmployee: 'Eliminar Empleado',
      credential: 'Credencial de Empleado',
      close: 'Cerrar',
      print: 'Imprimir',
      addNewEmployee: 'Agregar Nuevo Empleado',
      fullName: 'Nombre Completo',
      email: 'Email',
      rfidCode: 'Código RFID',
      daysPerWeek: 'días/semana',
      uploadPhoto: 'Subir Foto',
      selectPhoto: 'Seleccionar Foto',
      selectedFile: 'Archivo seleccionado:',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      update: 'Actualizar',
      save: 'Guardar',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
      logoSize: 'Tamaño del Logo',
      photoSize: 'Tamaño de la Foto',
      qrSize: 'Tamaño del QR',
      saveCustomization: 'Guardar Personalización',
      customizationSaved: 'Personalización guardada con éxito',
      customizationError: 'Error guardando personalización',
    },
    
    // --- Visitors ---
    visitors: {
      title: 'Gestión de Visitantes',
      subtitle: 'Administra el registro y control de visitantes en tu instalación',
      totalVisitors: 'Total Visitantes',
      registeredInSystem: 'Registrados en el sistema',
      today: 'Hoy',
      todayVisitors: 'Visitantes de hoy',
      thisWeek: 'Esta Semana',
      last7Days: 'Últimos 7 días',
      thisMonth: 'Este Mes',
      monthVisitors: 'Visitantes del mes',
      actions: 'Acciones',
      manageVisitors: 'Gestiona los visitantes',
      addVisitor: 'Agregar Visitante',
      visitorsList: 'Registro de Visitantes',
      showing: 'Mostrando',
      visitors: 'visitantes',
      visitor: 'Visitante',
      identification: 'Identificación',
      visitReason: 'Motivo de Visita',
      visitDate: 'Fecha de Visita',
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      identificationNumber: 'Número de Identificación',
      cancel: 'Cancelar',
      save: 'Guardar',
    },
    
    // --- Employee Access ---
    employeeAccess: {
      title: 'Acceso de Empleado',
      subtitle: 'Control de acceso y seguimiento de tiempo para empleados',
      selectAccessMethod: 'Selecciona tu método de acceso',
      chooseYourAccessMethod: 'Elige cómo quieres acceder al sistema',
      qrCode: 'Código QR',
      phone: 'Teléfono',
      scanQrCodeToAccess: 'Escanee su código QR para acceder al sistema',
      activateQrScanner: 'Activar Escáner QR',
      qrScannerActive: 'Escáner QR Activo',
      phoneVerification: 'Verificación por Teléfono',
      enterLast4Digits: 'Ingresa los últimos 4 dígitos de tu número de teléfono',
      last4Digits: 'Últimos 4 dígitos',
      onlyNumbers0to9: 'Solo números 0-9',
      selectAction: 'Selecciona una acción',
      chooseYourAction: 'Elige qué quieres hacer',
      startBreak1: 'Iniciar Descanso 1',
      endBreak1: 'Terminar Descanso 1',
      startBreak2: 'Iniciar Descanso 2',
      endBreak2: 'Terminar Descanso 2',
      startBreak3: 'Iniciar Descanso 3',
      endBreak3: 'Terminar Descanso 3',
      employeeVerified: 'Empleado Verificado',
      prepareForCapture: 'Preparar para captura facial...',
      newAccess: 'Nuevo Acceso',
    },
    
    // --- Access Validation ---
    accessValidation: {
      title: 'Validación de Acceso',
      subtitle: 'Revisar y gestionar solicitudes de acceso',
      totalRequests: 'Total de Solicitudes',
      pendingRequests: 'Solicitudes pendientes',
      approved: 'Aprobadas',
      approvedRequests: 'Solicitudes aprobadas',
      rejected: 'Rechazadas',
      rejectedRequests: 'Solicitudes rechazadas',
      pending: 'Pendiente',
      awaitingReview: 'En espera de revisión',
      accessRequests: 'Solicitudes de Acceso',
      showing: 'Mostrando',
      requests: 'solicitudes',
      requester: 'Solicitante',
      requestType: 'Tipo de Solicitud',
      requestDate: 'Fecha de Solicitud',
      status: 'Estado',
      actions: 'Acciones',
      viewDetails: 'Ver Detalles',
      approve: 'Aprobar',
      reject: 'Rechazar',
      requestDetails: 'Detalles de la Solicitud',
      email: 'Correo Electrónico',
      reason: 'Motivo',
      additionalInfo: 'Información Adicional',
      noAdditionalInfo: 'No se proporcionó información adicional',
      close: 'Cerrar',
      requestApproved: 'Solicitud aprobada exitosamente',
      requestRejected: 'Solicitud rechazada exitosamente',
      errorApproving: 'Error aprobando solicitud',
      errorRejecting: 'Error rechazando solicitud',
    },
    
    // --- Printable Card ---
    printableCard: {
      companyLogo: 'Logo de la Empresa',
      schedule: 'Horario',
      workDays: 'Días de Trabajo',
    },
    
    // --- User Profile ---
    userProfile: {
      title: 'Perfil de Usuario',
      subtitle: 'Gestiona tu información personal y configuraciones',
      profileInformation: 'Información del Perfil',
      managePersonalInfo: 'Actualiza tus datos personales',
      changeAvatar: 'Cambiar Avatar',
      personalInformation: 'Información Personal',
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      position: 'Posición',
      department: 'Departamento',
      saveChanges: 'Guardar Cambios',
      changesSaved: 'Cambios guardados exitosamente',
      errorSavingChanges: 'Error guardando cambios',
      accountSettings: 'Configuración de Cuenta',
      changePassword: 'Cambiar Contraseña',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmNewPassword: 'Confirmar Nueva Contraseña',
      updatePassword: 'Actualizar Contraseña',
      passwordUpdated: 'Contraseña actualizada exitosamente',
      errorUpdatingPassword: 'Error actualizando contraseña',
      preferences: 'Preferencias',
      language: 'Idioma',
      timezone: 'Zona Horaria',
      theme: 'Tema',
      lightTheme: 'Tema Claro',
      darkTheme: 'Tema Oscuro',
      savePreferences: 'Guardar Preferencias',
      preferencesSaved: 'Preferencias guardadas exitosamente',
      errorSavingPreferences: 'Error guardando preferencias',
    },
  },
};

// Language detection and management
export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  return langCode === 'es' ? 'es' : 'en';
};

export const getStoredLanguage = () => {
  return localStorage.getItem('appLanguage') || getBrowserLanguage();
};

export const setStoredLanguage = (language) => {
  localStorage.setItem('appLanguage', language);
};

// Translation function with interpolation support and nested key handling
export const t = (key, language = 'en', params = {}) => {
  const lang = language || getStoredLanguage();
  
  // Handle nested keys (e.g., 'login.welcome' -> translations[lang].login.welcome)
  const keys = key.split('.');
  let translation = translations[lang];
  
  // Navigate through nested objects
  for (const k of keys) {
    if (translation && typeof translation === 'object' && k in translation) {
      translation = translation[k];
    } else {
      // Fallback to English
      translation = translations['en'];
      for (const fallbackKey of keys) {
        if (translation && typeof translation === 'object' && fallbackKey in translation) {
          translation = translation[fallbackKey];
        } else {
          translation = key; // Return the key if not found
          break;
        }
      }
      break;
    }
  }
  
  // If translation is not a string, return the key
  if (typeof translation !== 'string') {
    translation = key;
  }
  
  // Handle parameter interpolation
  Object.keys(params).forEach(param => {
    translation = translation.replace(`{${param}}`, params[param]);
  });
  
  return translation;
};

// Note: useLanguage hook is now in LanguageContext.js
// Use the one from contexts/LanguageContext instead 